<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot title="Captains & Directors" />
        
        <v-card flat class="transparent mt-10 pa-6" v-if="loaded">
            <!-- FRANCO & TOMAS -->
            <template>
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="d-flex align-center"> <!-- FRANCO -->
                            <UserAvatar :photo="franco.photo" size="100px" class="elevation-3"/>
                            <div class="ml-4">
                                <div class="headline font-weight-light black--text">{{franco.name}}</div>
                                <v-btn text class="accent--text ml-n4 mt-n2" @click="$router.push('/captain-profile/'+franco.uid)">Visit my profile</v-btn>
                                <div>
                                    <v-btn text class="primary--text ml-n4 mt-n6">Ask your 3S Captain</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="d-flex align-center"> <!-- TOMAS -->
                            <UserAvatar :photo="tomas.photo" size="100px" class="elevation-3"/>
                            <div class="ml-4">
                                <div class="headline font-weight-light black--text">{{tomas.name}}</div>
                                <v-btn text class="accent--text ml-n4 mt-n2" @click="$router.push('/captain-profile/'+tomas.uid)">Visit my profile</v-btn>
                                <div>
                                    <v-btn text class="primary--text ml-n4 mt-n6">Ask your 3S Captain</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </template>

            <v-row>
                <v-col cols="12" sm="6" v-for="item in items" :key="item.uid" v-if="item.email!='franco@ypdgroup.com' && item.email!='tomas.mayorga@3stepstocollege.com'">
                    <div class="d-flex align-center" >
                        <UserAvatar :photo="item.photo" size="100px" class="elevation-3"/>
                        <div class="ml-4">
                            <div class="headline font-weight-light black--text">{{item.name}}</div>
                            <v-btn text class="accent--text ml-n4 mt-n2" @click="$router.push('/captain-profile/'+item.uid)">Visit my profile</v-btn>
                            <div>
                                <v-btn text class="primary--text ml-n4 mt-n6">Ask your 3S Captain</v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <SendingLoader v-if="!loaded"/>
	</v-card>
</template>

<script>
import Helpers from '@/services/helpers'
import Users from '@/firebase/users'

export default {
    data: () => ({
        loaded: false,
        items: [],
        FRANCO_UID: '9mIKyPGwSjQ5jYtQ9WtWRLZJpaO2',
        TOMAS_UID: 'F96yGPllR5elMhAFKgTxhwl3rg12',
        franco: null,
        tomas: null
    }),
    components: {
        
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Users.getCaptains()
                .then(response => {
                    if (response.status === true) {
                        this.items = Helpers.formatItems(response.query, 'uid');
                        this.getFranco();
                    } 
                });
        },
        getFranco() {
            Users.get(this.FRANCO_UID)
                .then(response => {
                    if (response.status === true) {
                        this.franco = response.doc.data();
                        this.franco.uid = response.doc.id;
                        this.getTomas();
                    }
                });
        },
        getTomas() {
            Users.get(this.TOMAS_UID)
                .then(response => {
                    if (response.status === true) {
                        this.tomas = response.doc.data();
                        this.tomas.uid = response.doc.id;
                        this.loaded = true;
                    }
                });
        }
    }
}
</script>

